import script from "./InputTelefono.vue?vue&type=script&setup=true&lang=js"
export * from "./InputTelefono.vue?vue&type=script&setup=true&lang=js"

import "./InputTelefono.vue?vue&type=style&index=0&id=79cd8e83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cd8e83"]])

export default __exports__